import { Avatar, Label, Text } from 'components';
import { TEXT_STRING } from '../../constants';
import { TMaleDetail } from 'types';

const STR = TEXT_STRING.CALL_WOMAN;

type Props = {
  roster: TMaleDetail[];
  activeInvitedMaleIds: number[];
  onToggleInvitedMale: (maleId: number) => void;
};

function InvitedMalesCards({
  roster,
  activeInvitedMaleIds,
  onToggleInvitedMale,
}: Props) {
  if (!roster.length) return null;

  const activeSet = new Set(activeInvitedMaleIds);

  return (
    <div className="w-full flex flex-col gap-8px">
      <div className="flex items-center gap-4">
        <Label className="text-sm" bold>
          {STR.INPUT_MALE_ID}
        </Label>
      </div>
      <div className="flex w-full flex-col gap-2">
        {roster.map((male) => {
          const isOn = activeSet.has(male.id);
          return (
            <button
              key={male.id}
              type="button"
              onClick={() => onToggleInvitedMale(male.id)}
              className={`flex w-full flex-row items-center gap-3 rounded-md border px-4 py-2 text-left transition
                ${
                  isOn
                    ? 'border-primary-400 bg-primary-50 opacity-100 ring-1 ring-primary-200'
                    : 'border-neutral-200 bg-neutral-50 opacity-50 grayscale'
                }`}
            >
              <Avatar url={male.avatar} size="w-12" circle />
              <div className="flex min-w-0 flex-1 flex-row items-baseline gap-0.5 truncate">
                <Text fontSize={14} bold className="min-w-0 truncate">{male.nickname} ({male.id})</Text>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default InvitedMalesCards;
